import React, { useEffect, useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllCities, removePinCityFromStore, editWarehouse } from '../../../actions/inventory';
import { closeModalAction } from '../../../actions/modal';
import { actualValueForDropdown } from '../../../utils/common';
import Form from '../../../common/Form';
import Input from '../../../common/Form/Input';
import { useForm } from 'react-hook-form';
import Address, { transformAddress } from '../../../components/Inputs/Address';
import RenderContact from '../../../components/Inputs/Contact';

const EditInventoryWarehouse = ({ modalData }) => {
    const formName = 'editWarehouse';
    const dispatch = useDispatch();
    const { formButtonLoading } = useSelector((state) => state.loading);

    useEffect(() => {
        dispatch(getAllCities());
        return () => dispatch(removePinCityFromStore());
    }, [dispatch]);

    const defaultValues = {
        warehouseName: modalData.external_id,
        pincode: modalData.pincode,
        address: modalData.address,
        name: modalData.warehouseContactName,
        mobile: modalData.warehouseContactPhone,
        email: modalData.warehouseContactEmail,
    };

    const submit = (form) => {
        let contact = [];
        if (actualValueForDropdown(form?.contact) === 'add-new-contact') {
            let own = {};
            if (form[`contact:name`]?.trim()) {
                own.name = form[`contact:name`]
            }
            if (form[`contact:email`]) {
                own.email = form[`contact:email`]
            }
            if (form[`contact:mobile`]) {
                own.mobile = form[`contact:mobile`]
            }
            if (Object.keys(own).length > 0) contact.push(own);
        } else if (form.contact) {
            if (Array.isArray(form.contact)) {
                form.contact.forEach(item => {
                    const findIfExists = modalData.owners.find(owner => owner.owner_id === item.id);
                    if (!findIfExists) {
                        contact.push({
                            id: item.id,
                            name: item.name,
                            email: item.email,
                            mobile: item.mobile
                        });
                    };
                });
            } else {
                const findIfExists = modalData.owners.find(owner => owner.owner_id === form.contact.id);
                if (!findIfExists) {
                    contact.push({
                        id: form.contact.id,
                        name: form.contact.name,
                        email: form.contact.email,
                        mobile: form.contact.mobile
                    });
                }
            }
        }

        let payload = {
            address: transformAddress(form, 'address'),
            external_id: form.warehouseName,
        }
        if (contact && contact.length > 0) {
            payload.owners = contact;
        }
        if (modalData.address === payload.address.plain_text) {
            delete payload.address;
        }
        dispatch(editWarehouse({ payload, id: modalData.id }))
    };

    const closeModal = () => {
        dispatch(closeModalAction());
    };

    const methods = useForm({ defaultValues, mode: 'all' });

    return (
        <>
            <Form
                className='w-full'
                onSubmit={submit}
                onCancel={closeModal}
                defaultValues={defaultValues}
                submitButtonText={'Update'}
                showSubmit
                submitContainerClassName='flex gap-2 justify-end py-4 px-4'
                isLoading={formButtonLoading[formName]}
                methods={methods}
            >
                <EditWarehouseInputs modalData={modalData} location={modalData} />
            </Form>
        </>
    );
};

const EditWarehouseInputs = ({ modalData, location }) => {
    const methods = useForm({ defaultValues: {}, mode: 'all' });

    const handleAddressChange = (validatedAddress) => {
        methods.setValue('address', validatedAddress); // Update form state
    };

    const prefillOwners = useMemo(() => {
        let prefill = [];
        if (location?.owners) {
            location?.owners?.forEach(({ owner_id }) => {
                prefill.push(owner_id);
            });
        }
        return prefill.length > 0 ? prefill : [];
    }, [location]);


    return (
        <div className='w-full px-3'>
            <div className='grid grid-cols-1 md:grid-cols-2 w-full gap-4'>
                <Input
                    label='Warehouse Name'
                    required
                    name='warehouseName'
                    type={'text'}
                    placeholder={'Warehouse Name'}
                    className='w-full'
                />
                <Address
                    id="address"
                    name="address"
                    label=" Address"
                    required={true}
                    placeholder="Type your address..."
                    onChange={handleAddressChange}
                    prefill={modalData.address}
                    className='w-full'
                />
                <div className='md:col-span-2'>
                    <RenderContact
                        name={'contact'}
                        label={'Contact Name'}
                        org_id={actualValueForDropdown(location.org_id)}
                        prefill={prefillOwners}
                    />
                </div>
            </div>
        </div>
    );
};

export default EditInventoryWarehouse;
